module.exports = "/packs/media/images/protection1-13d7d0a862531a0b121960b028dd4076.jpg";